export enum CalibrationType {
  WHITE_REFERENCE = "WHITE_REFERENCE",
  SPECTRAL_REFERENCE = "SPECTRAL_REFERENCE",
}
